import { Box } from '@mui/material';
import ConstructionOutlined from '@mui/icons-material/ConstructionOutlined';
import { useTranslation } from 'react-i18next';
import { EmptyState, PageHeader } from '../../components';
import { SA_ROUTES } from './saNav';

/**
 * Placeholder for a console section not yet built (slices 17–21). Renders the
 * section's real title + subtitle in the console header (so the nav destination
 * and breadcrumb are faithful) over a "coming soon" body. Each becomes a real
 * screen as its slice lands.
 */
export function SaStubPage({ routeId }: { routeId: string }) {
  const { t } = useTranslation();
  const leaf = SA_ROUTES.find((r) => r.id === routeId);
  const title = t(leaf?.titleKey ?? leaf?.labelKey ?? 'siteAdmin:pageTitle.home');
  const subtitle = leaf ? t(leaf.subtitleKey) : undefined;

  return (
    <>
      <PageHeader title={title} subtitle={subtitle} />
      <Box
        sx={{
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: '8px',
        }}
      >
        <EmptyState
          icon={<ConstructionOutlined sx={{ fontSize: 26 }} />}
          title={t('stub.comingSoonTitle')}
          message={t('stub.comingSoonBody')}
        />
      </Box>
    </>
  );
}
